export default __webpack_public_path__ + "device_floodlight_cam.458bdd69.png";